export const EmptyURIValue = 'all';

export const UriDelimiter = '.';
